<template>
  <div ref="canvas" class="analysis-section">
    <div class="heading">
      <slot name="header"></slot>
      <i v-if="!isIE && !printing" class="icon-download" @click="print" />
      <slot v-if="!printing" name="action"></slot>
    </div>
    <div class="analysis-table" :class="{ exporting: printing }">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import html2canvas from 'html2canvas';

export default {
  data() {
    return {
      printing: false,
    };
  },

  computed: {
    ...mapGetters({
      globalFilters: 'globalFilters',
    }),

    isIE() {
      const ua = navigator.userAgent;
      /* MSIE used to detect old browsers and Trident used to newer ones */
      const isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;

      return isIE;
    },
  },

  methods: {
    async print() {
      this.printing = true;

      setTimeout(() => {
        const cloneNone = this.$refs.canvas;
        const svg = cloneNone.querySelector('svg');

        let oldHeight;
        let oldWidth;

        if (svg) {
          oldHeight = svg.getAttribute('height');
          oldWidth = svg.getAttribute('width');
          const { height, width } = svg.viewBox.baseVal;
          svg.setAttribute('height', height);
          svg.setAttribute('width', width);
        }

        html2canvas(cloneNone, { useCORS: true }).then(canvas => {
          let link = document.createElement('a');
          link.download = `${this.globalFilters.currentMatchingTime}${this.$el.querySelector('h5').innerHTML}.png`;
          link.href = canvas.toDataURL();
          link.click();

          if (svg) {
            svg.setAttribute('height', oldHeight);
            svg.setAttribute('width', oldWidth);
          }

          this.printing = false;
        });
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.icon-download {
  font-size: 1.5em;
  cursor: pointer;

  &:hover {
    color: colors.$main-color;
  }
}

.action-button {
  margin-left: auto;
  margin-right: 12px;
  padding: 8px 12px;
  border: solid 1px colors.$nude-concrete-color;
  border-radius: 8px;
  color: colors.$dark-grey-color;
  transition: 200ms ease-in-out;
  cursor: pointer;

  &:hover {
    background: colors.$clear-border-color;
  }

  &:active {
    opacity: 0.8;
  }
}

.action-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 192px;
  font-size: 12px;
  margin: 0 16px 0 auto;

  .action-button {
    border-radius: 0;
    border-color: colors.$navy-color;
    margin: 0;
    min-width: 78px;
    text-align: center;

    &:first-child {
      border-radius: 8px 0 0 8px;
      border-right: 0;
    }
    &:last-child {
      border-radius: 0 8px 8px 0;
      border-left: 0;
    }
    &:hover {
      background: rgba(colors.$navy-color, 0.2);
    }

    &.long {
      min-width: 134px;
    }

    &.active {
      background: colors.$navy-color;
      color: colors.$white-color;
      font-weight: bold;
    }
  }
}
</style>
